module.exports = __webpack_public_path__ + "static/media/blr.ccfacfab.png";